import React, { useRef } from 'react'
import { Breadcrumbs } from "@material-tailwind/react";
import { Link, useLocation, useNavigate } from 'react-router-dom'
import { useState, useEffect } from 'react';
import Loading from '../../../COMPONENTS/Loading/Loading'
import SidebarTop from '../../SidebarTop';
import OM from '../../../../ASSETS/tourisme/icone/orange-money-logo-8F2AED308D-seeklogo.com.png'
import MOMO from '../../../../ASSETS/tourisme/icone/1678624190074.png'
import WAVE from '../../../../ASSETS/tourisme/icone/0PZcR8OO_400x400.jpg'
import MOOV from '../../../../ASSETS/tourisme/icone/unnamed.png'
import Visa from '../../../../ASSETS/tourisme/icone/Visa-logo.jpg'
import MasterCard from '../../../../ASSETS/tourisme/icone/MasterCard-Logo-1-1024x768.jpg'
import paiement from '../../../../ASSETS/tourisme/Image/65Z_2201.w012.n001.25B.p12.25-removebg-preview.png'
import { Dialog, DialogTitle, IconButton, styled } from '@mui/material';
import { loadStripe } from '@stripe/stripe-js';
import { toast, ToastContainer } from 'react-toastify';
import axios from 'axios';
import CloseIcon from '@mui/icons-material/Close';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import { Button } from 'react-bootstrap';
import Create from '../../../../Payment/Create';



const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(1),
    },
}));



function Recharge() {

  const [loading, setLoading] = useState(true);
  const [montant,setMontant] = useState();
  const [open,setOpen] = useState(false)
  const location = useLocation()
  const [curr,setCurr] = useState();
  const [options, setOptions] = useState(null);
  const hasRun = useRef(false);
  const navigate = useNavigate()
  const [data, setData] = useState(() => {
          const saved = localStorage.getItem("data");
          const initialValue = saved !== null ? JSON.parse(saved) : null;
          return initialValue;
      });

    //const params = new URLSearchParams(window.location.search)
    const prod = localStorage.getItem('provider');
    const payementId = localStorage.getItem('payementId')
    const idCurrency = localStorage.getItem('id_currency') 
   

    useEffect(() => {
     
        // Appel API pour récupérer la monnaie
        axios
          .get(`${process.env.REACT_APP_BASE_URL}/api/get/info/website`)
          .then((res) => {
            if (res.data.status === 200 ) {
              setCurr(res.data.currency);
              localStorage.setItem('id_currency', res.data.currency.id_currency);
            } else {
              console.warn("Réponse inattendue de l'API :", res.data);
            }
          })
          .catch((err) => {
            console.error("Erreur lors de l'appel à l'API :", err);
          });
      
        // Timer pour masquer le spinner
        const timer = setTimeout(() => {
          setLoading(false);
        }, 2000); // 2000 ms = 2 secondes (tu as noté 5s dans le commentaire mais mis 2s dans le code)
      
        // Nettoyage du timer
        return () => clearTimeout(timer);
      }, []);
      

  const handleChange = (e)=>{
     setMontant(e.target.value)
  }

  const handleSubmit = (e)=>{
     e.preventDefault();
     let amount = parseFloat(montant)
     if(!amount || amount <= 0)
     {
      toast.error("Veuillez entrer un montant valide")
      setOpen(false)
      return ;
     }else{
      setOpen(true)
     }
  }

  const StoreRecharge = (provider,paymentId,currencyId)=>{
    
     const formData={
        userId:data.azId,
        montant:montant,
        provider: provider,
        payement_id: paymentId,
        currency:currencyId,
        recharge: 'recharge',
    }
      // if (hasRun.current) return;
      // hasRun.current = true;
    if(provider && paymentId && currencyId ){
        axios.post(`${process.env.REACT_APP_BASE_URL}/api/store/rechargement-paiememnt`,formData)
        .then((res)=>{
          if(res.data.status === 200){
            localStorage.removeItem('montant')
            setOpen(false)
            setMontant('')
            toast.success(res.data.message);
          }
        }).catch((err)=>{
           console.log("Erreur lors de l'appel a l'API ",err)
        })
    }
  }
  useEffect(() => {
    if (curr) {

      setOptions({
        id_currency: curr.id_currency,
        success_url: window.location.origin + location.pathname,
        cancel_url: window.location.href,
        amount: parseFloat(montant),
        customer: {
          id: 106,
          first_name: 'Jean',
          last_name: 'DUPONT',
          email: 'jeandupont@gmail.com',
          phone: '64000001',
          code_country: 'BJ'
        },
        seller_number: 1
      });
    }
  }, [curr,montant]);

 

  return (
    <div className='flex flex-row bg-[#eeee] '>
      {loading ? (
        // Afficher le spinner tant que loading est true
        <Loading />
      ) : (
        <>
          <div className='w-screen  barre_scroll h-screen'>
            <ToastContainer/>
            {/* sidebar top  */}
            <SidebarTop />
            {/* navbar top gris*/}
            <div className='bg-[#f7f7f7] sm:h-10 s:h-14 mt-[50px]'>
              <Breadcrumbs >
                <Link to="" className="opacity-60">
                  Achat de credit
                </Link>
                <Link to="" className="opacity-60">
                  Recharge
                </Link>

              </Breadcrumbs>
            </div>
            {/* container formulaire */}
            <div className='  h-screen md:p-10 s:p-4 space-y-5  '>
              <div className='flex s:flex-col s:space-y-10 md:space-y-0 md:flex-row md:space-x-28'>
                <div className='flex flex-col space-y-5'>
                    <div className='md:text-4xl s:text-3xl font-semibold text-[#4e4e4e] '>
                      Rechargement de la carte Credit AZ
                    </div>
                    <div className='md:w-[800px]'>
                        Lorem ipsum dolor sit amet, consectetur adipiscing
                        elit. Ut consectetur orci massa, in posuere felis
                        condimentum sagittis. Cras posuere, dui eu feugiat
                        dignissim, dolor turpis sollicitudin nulla, sed interdum
                        diam neque a sem. Aenean viverra lacus vitae imperdiet laoreet.
                        Praesent ac eros at risus condimentum semper.
                    </div>
                    <hr className='md:w-[800px]'/>
                    <div className='text-3xl font-semibold text-[#4e4e4e]'>Option de recharge</div>
                    <div className='md:w-[800px]'>
                        Vestibulum viverra leo ut purus interdum faucibus. Morbi a vulputate justo.
                        Praesent viverra convallis nunc, id fermentum tellus efficitur eget.
                    </div>
                </div>
                <img src={paiement} alt='paiement' className='w-[400px]'/>
              </div>

             <div className='flex s:flex-col s:space-y-10 md:space-y-0 md:flex-row md:space-x-10 justify-center'>
                {/* PAR CARTE BANCAIRE */}
                <form onSubmit={handleSubmit} className='flex flex-col space-y-5'>
                  {/* <div className='flex flex-row items-center space-x-2'>
                    <input type='radio'  onChange={handleChange}
                           name='Option_paiement'
                           value='bancaire'
                           checked={optionPaiement === 'bancaire'}
                           />
                    <div>Par Carte bancaire</div>
                    <div className='flex flex-row items-center space-x-3'>
                      <img src={Visa} alt='Visa' className='w-14'/>
                      <img src={MasterCard} alt='MasterCard' className='w-14'/>
                    </div>
                  </div> */}
                  {/* <div className='flex flex-row items-center space-x-2'>
                    <input type='radio' onChange={handleChange}
                           name='Option_paiement'
                           value='momo'
                           checked={optionPaiement === 'momo'}
                           />
                    <div>Par Mobile Money</div>
                    <div className='grid xs:grid-cols-4 s:grid-cols-2 place-content-center place-items-center gap-3'>
                      <img src={OM} alt='OM' className='w-14'/>
                      <img src={MOMO} alt='MOMO' className='w-14'/>
                      <img src={WAVE} alt='WAVE' className='w-14'/>
                      <img src={MOOV} alt='MOOV' className='w-14'/>
                    </div>
                  </div> */}
                  {/* {
                    bancaire && (
                      <div>
                        <div className='flex flex-col space-y-2'>
                            <label className='text-lg'>Nom du propriétaire de la carte</label>
                            <input type='text' name='numero' className='xs:w-[400px] '/>
                        </div>
                        <div className='flex flex-col space-y-2'>
                          <label className='text-lg'>Numero de carte</label>
                          <input type='text' name='numero' className='xs:w-[400px] '/>
                        </div>
                        <div className='flex s:flex-col s:space-y-6 sm:space-y-0 sm:flex-row sm:items-center sm:space-x-6'>
                          <div className='flex flex-col space-y-2'>
                            <label className='text-lg'>Date d'expiration</label>
                            <input type='month' name='numero' className='w-[150px] '/>
                          </div>
                          <div className='flex flex-col space-y-2'>
                            <label className='text-lg'>CVC</label>
                            <input type='number' name='numero' className='w-[150px] '/>
                          </div>
                        </div>
                    </div>
                    )
                   } */}
                   {

                      <div className='flex flex-col space-y-2'>
                        <label className='text-lg'>Entrer le montnant a recharger</label>
                        <input type='number'
                               name='montnant'
                               value={montant}
                               className='xs:w-[400px]'
                               onChange={handleChange}
                               />
                       </div>

                   }


                <button className='bg-[#FE7F2D] w-[150px] text-white text-lg h-10 rounded '>Recharger</button>
                </form>
             </div>
                {
                  open && (
                    <div className="fixed inset-0 flex items-center justify-center bg-gray-500 bg-opacity-50 z-50">
                      <div className="bg-white rounded-lg p-6 w-full max-w-3xl relative max-h-screen overflow-y-auto">
                          {/* Bouton de fermeture à l'intérieur du modal */}
                          <button
                          onClick={() => setOpen(false)}
                          className="absolute top-3 right-3 text-red-500 text-2xl"
                        >
                          &times;
                        </button>
                         <Create item="Rechargement de la carte AZ" options={options} onSuccess={StoreRecharge} ></Create>
                      </div>
                    </div>
                  )
                }
            </div>
          </div>
        </>
      )}
    </div>
  )
}

export default Recharge